import { Editor, Element, Node, Transforms } from 'slate';

/**
 * A "list-item-text" can have only inline nodes in it.
 */
export function normalizeListItemTextChildren(editor, _ref) {
  var [node, path] = _ref;

  if (!editor.isListItemTextNode(node)) {
    // This function does not know how to normalize other nodes.
    return false;
  }

  for (var [childNode, childPath] of Node.children(editor, path)) {
    if (Element.isElement(childNode) && !Editor.isInline(editor, childNode)) {
      Transforms.unwrapNodes(editor, {
        at: childPath
      });
      return true;
    }
  }

  return false;
}